import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

const Login = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const history = useHistory();

  const handleChange = e => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
    setError(''); // Clear error on input change
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Simulate async login request
    setTimeout(() => {
      if (credentials.username === 'Mike' && credentials.password === 'Kipsang123') {
        localStorage.setItem('token', 'mock-token');
        history.push('/overview');
      } else {
        setError('Invalid username or password');
        setLoading(false);
      }
    }, 1000); // Simulate 1-second delay for loading
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-lg border border-gray-200">
        <h1 className="text-3xl font-sftsBold text-black mb-6 text-center font-['Inter']">Admin</h1>
        {error && (
          <div className="mb-4 p-3 bg-red-100 border-l-4 border-red-500 text-red-700 text-sm rounded font-['Open_Sans']">
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="username" className="block text-sm font-sftsMedium text-black font-['Open_Sans']">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={credentials.username}
              onChange={handleChange}
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-300 text-black placeholder-gray-400 font-sftsMedium"
              placeholder="Enter username"
              required
              disabled={loading}
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-black font-sftsMedium">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-300 text-black placeholder-gray-400 font-sftsMedium"
              placeholder="Enter password"
              required
              disabled={loading}
            />
          </div>
          <button
            type="submit"
            className={`w-full px-4 py-2 bg-green-300 text-black font-sftsMedium rounded-md hover:bg-green-400 transition-colors duration-200 flex items-center justify-center ${loading ? 'opacity-50 cursor-not-allowed' : ''} font-['Open_Sans']`}
            disabled={loading}
          >
            {loading ? (
              <>
                <svg className="animate-spin h-5 w-5 mr-2 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Logging in...
              </>
            ) : (
              'Login'
            )}
          </button>
        </form>
      </div>
      <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600&family=Open+Sans:wght@400&display=swap');
      `}</style>
    </div>
  );
};

export default Login;
